import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { ViaviTableComponent } from './component/viavi-table/viavi-table.component';

@NgModule({
  imports: [CommonModule, CommonMaterialModule, CommonLibModule, MatMenuModule, FormsModule],
  declarations: [ViaviTableComponent],
  exports: [ViaviTableComponent]
})
export class ViaviTabulatorModule {}
